<template>
  <div>
    <v-dialog v-model="isUploading" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Upload Cites and Quarters</span>
          <v-btn text icon dark @click="isUploading = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <Upload :upload-url="url" @uploaded="handleUpload" />
        </v-container>
      </v-card>
    </v-dialog>
    <v-data-iterator :items="citiesAndQuarters" :items-per-page="5" class="elevation-1">
      <template v-slot:header>
        <v-toolbar class="mb-2" color="grey lighten-4" light tile flat>
          <v-toolbar-title>Cities and Quarters</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="isUploading = true" color="primary">
            <v-icon>mdi-file-document-box-plus-outline</v-icon>Upload Cities and Quarters
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:default="props">
        <v-row class="mx-2">
          <v-col v-for="item in props.items" :key="item.city" cols="12" sm="6" md="4" lg="3">
            <v-card>
              <v-card-title class="subheading font-weight-bold text-capitalize">
                {{ item.city }}
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item v-for="(quarter, index) in item.quarters" :key="index">
                  <v-list-item-content class="align-start">
                    {{ quarter }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col></v-row
        ></template
      >
    </v-data-iterator>
  </div>
</template>

<script>
import Upload from "@/components/documents/upload";

export default {
  props: {
    data: { required: true, type: Object },
    countryId: { required: true, type: [String, Number] },
  },
  components: { Upload },
  data() {
    return {
      isUploading: false,
      headers: [
        {
          text: "City",
          align: "start",
          value: "city",
        },
        { text: "Quarters", value: "quarters" },
      ],
      citiesAndQuarters: this.extractData(this.data),
    };
  },
  computed: {
    url() {
      return `/api/v1/transactions/transferCountries/${this.countryId}/citiesAndQuarters`;
    },
  },
  methods: {
    handleUpload({ message, transferCountry }) {
      this.isUploading = false;
      Notify.success(message);
      this.citiesAndQuarters = this.extractData(transferCountry.city_quarters);
    },
    extractData(data) {
      return Object.keys(data).map((key) => {
        let rObj = {};
        rObj["city"] = key;
        rObj["quarters"] = data[key];
        return rObj;
      });
    },
  },
};
</script>

<style></style>
